<template>
    <div class="configCard">
        <CheckBox fieldClass="configCard-title" :isDisabled="disabled" :fieldLabel="checkboxLabel" :field="checkboxField" :isChecked="checkBoxChecked"
        @checked-item="updateCurrItem($event, carID)"/>
        <div class="configCard-specs">
            <p v-for="(item, i) in carSpecs" :key="i">{{item}}</p>
        </div>
        <div class="configCard-details">
            <slot></slot>
            <div class="configCard-details-price">
                <p>Preço total desde</p>
                <div class="priceWrap">
                    <p class="h3">{{ parseFloat(carPrice).toFixed(0) | format_thousands}} €</p>
                    <svg @click="openModal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/></svg>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapMutations, mapState } from 'vuex';
    import CheckBox from '../../FormFields/CheckBox/CheckBox.vue'
    import { modalPrice } from '../../../mixins/modalFunctions'
    import { cookiesFunc } from '../../../mixins/cookiesFunc'

    export default {
        name: 'ConfigCard',
        components: { CheckBox, },
        props:{
            disabled: {type: Boolean, default: false},
            checkboxLabel: {type: String},
            checkboxField: {type: String},
            checkBoxChecked: {type: Boolean, default: false},
            selectedEngine: {type: [String, Number]},
            carID: {type: Number},
            carSpecs: {type: Array, default: () => { return []; }},
            carPrice: {type: [String, Number]},
            objectID: {type: [String, Number]},
            rent: {type: [String, Number]},
            taeg: {type: [String, Number]},

            itemObj: {type: Object, default: () => { return {}; }},
        },
        mixins: [modalPrice, cookiesFunc],
        inject:['page'],
        mounted(){
            this.checkBoxChecked && this.updateCurrItem(null, null, this.checkBoxChecked)
        },
        data(){ return{
            modalParam: 1, // set modal finance param
        }},
        computed: {
            ...mapState(['resumeData']),
        },
        methods: {
            ...mapMutations({
                updateConf: 'resumeData/UPDATE_CONFIGOPTIONS',
                changeState: 'resumeData/UPDATE_STATE',
                updateMotorSelection: 'modalData/UPDATE_MODALSTATE',
                updateResumeState: 'resumeData/UPDATE_STATE',
            }),
            openModal(){
                this.updateMotorSelection({
                    openModal: true,
                    component: 'DefaultModalContent',
                    title: this.setModalTitle(this.handleModalFinTitle),
                    content: this.setFinanceContent(true, this.handleModalFinData),
                })
                document.body.classList.add('isActive')
            },
            updateCurrItem(e, id, mount=false){
                this.page == 'Comparator' && this.$emit('update:value', {id : id, state: e });

                if(e === false){
                    this.page == 'Motor' && this.changeState({isMotorSelected: false})
                    this.page == 'Version' && this.changeState({isVersionSelected: false})
                    return
                }

                const item = this.itemObj;
                const versionID = this.resumeData.newCfg ? null : this.resumeData.versionID
                const price = parseFloat(this.carPrice).toFixed(0)
                let obj = {
                    basePrice: price,
                    rent: this.rent,
                    taeg: this.taeg,
                    maxMounths: item.nrPayments,
                    incialEntry: item.maxEntrance,
                    financing: price - item.maxEntrance,
                    creditType: 'CREDIT',
                };

                switch(this.page){
                    case 'Motor': {
                            const payload = Object.assign(obj, {
                                engineID: this.selectedEngine,
                                selectedEngine: this.objectID,
                                versionID: versionID,
                                wltp: item.autonomy,
                                power: item.power,
                                powerKw: item.powerKw,
                                isMotorSelected: true,
                            });

                            this.changeState(payload)

                            if(e || mount){
                                obj = { motor: { label: 'Motor', designation: this.checkboxLabel, price: price, route: 'Motors' }}
                                this.saveCookieCfgSteps(1)
                                break
                            }
                            obj = { motor: null };
                        }
                        break;

                    case 'Version': {
                            const payload = Object.assign(obj, {
                                versionID: this.objectID,
                                isVersionSelected: true
                            })

                            this.changeState(payload)

                            this.$store.dispatch('panoram360/fetchPanoramImg', this.resumeData.modelid);

                            if(e || mount){
                                obj = { version: { label: 'Versão', designation: this.checkboxLabel, price: price, route: 'Version', id: this.objectID }}
                                this.saveCookieCfgSteps(2)
                                break
                            }
                            obj = { version: null };
                        }
                        break;

                    // case 'Comparator': this.$emit('update:value', {id : id, state: e });
                    //     break;
                }

                if(e || mount){
                    this.updateConf(obj)
                    this.updateResumeState({hasFinances: false})
                }
            },
        }
    }
</script>
<style lang="scss">
    @import './ConfigCard.scss';
</style>
